// components/layout/Text.jsx

import { fontSize, fontWeight, colors, space } from "../../design/tokens";

const variants = {
  h1: { fontSize: fontSize.xxl, fontWeight: fontWeight.bold },
  h2: { fontSize: fontSize.xl,  fontWeight: fontWeight.bold },
  h3: { fontSize: fontSize.lg,  fontWeight: fontWeight.semibold },
  h4: { fontSize: fontSize.md,  fontWeight: fontWeight.semibold },
  body: { fontSize: fontSize.md, fontWeight: fontWeight.normal },
  small: { fontSize: fontSize.sm, fontWeight: fontWeight.normal },
};

export default function Text({ variant = "body", style, children, ...props }) {
  return (
    <p
      style={{
        margin: 0,
        color: colors.text,
        ...variants[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </p>
  );
}